export const isLoading = state => state.studiesReducer.studentCourseSession.attachment.isLoading

export const isSuccess = state => state.studiesReducer.studentCourseSession.attachment.isSuccess

export const attachments = state => state.studiesReducer.studentCourseSession.attachment.attachments

export const options = state => state.studiesReducer.studentCourseSession.attachment.options

export const permissions = state => state.studiesReducer.studentCourseSession.attachment.permissions
